import { useCallback, useEffect, useState } from 'react';
import { generatePath, useLocation, useNavigate } from 'react-router-dom';
import { GeneralLedgerTransaction } from '@ui/src';
import {
  useLazyGetCustomerGeneralLedgerTransactionQuery,
  useLazyGetCustomerStatementChangeLogsQuery,
} from '../../../../customers/store/services/customers';
import { clearTransactionState } from '../../../store/slices/problem-transactions/gl-transaction';
import { useAppDispatch } from '../../../../../../../../store/use-store';

const useProblemGLTrasnaction = ({
  transactionId,
  customerId,
  transaction,
  backPath,
}: {
  backPath: string;
  transactionId?: string;
  customerId?: string;
  transaction?: GeneralLedgerTransaction;
}) => {
  const [panelIsOpen, setPanelIsOpen] = useState(false);

  const { search } = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [getCustomerGeneralLedgerTransaction, { isLoading, isFetching }] =
    useLazyGetCustomerGeneralLedgerTransactionQuery();
  const [
    getTransactionChangeLogs,
    { isLoading: changeLogsIsLoading, isFetching: changeLogsIsFetching },
  ] = useLazyGetCustomerStatementChangeLogsQuery();

  const getTransactionChangeLogsAction = useCallback(
    (cursor?: string) => {
      getTransactionChangeLogs(
        `?take=20&entityType=GENERAL_LEDGER_TRANSACTION&entityId=${transactionId}${
          cursor ? `&cursor=${cursor}` : ''
        }`,
      );
    },
    [transactionId],
  );

  const handleClose = () => {
    setPanelIsOpen(false);

    setTimeout(() => {
      navigate(
        generatePath(`${backPath}${search || ''}`, {
          customerId,
        }),
      );
    }, 100);
  };

  useEffect(() => {
    setPanelIsOpen(true);

    return () => {
      dispatch(clearTransactionState());
    };
  }, [dispatch]);

  useEffect(() => {
    if (customerId && !transaction && transactionId) {
      getCustomerGeneralLedgerTransaction(transactionId);
    }
  }, [customerId, transaction, transactionId]);

  return {
    panelIsOpen,
    handleClose,
    isLoading,
    isFetching,
    changeLogsIsLoading,
    changeLogsIsFetching,
    getTransactionChangeLogsAction,
  };
};

export default useProblemGLTrasnaction;
